import React from "react";
import MyPortfolio from "container/portfolio/MyPortfolio";
import OthersPortfolio from "container/portfolio/OthersPortfolio";
import { withStore } from "store/storeHandler";
import PropTypes from "prop-types";

RootPortfolio.propTypes = {
  ownerName: PropTypes.string.isRequired
};

function RootPortfolio(props) {
  const { username, ownerName } = props;

  const isMine = () => {
    if (username === ownerName && typeof username !== "undefined") {
      return true;
    } else {
      return false;
    }
  };

  return isMine() ? <MyPortfolio /> : <OthersPortfolio ownerName={ownerName} />;
}

export default withStore({ stateMap: { myAccount: ["username"] } })(
  RootPortfolio
);
